export async function runWebSyncCommand({
  acknowledge,
  command,
  refreshWorkspace,
  retryRecoverable,
  session,
}) {
  let runningVersion = null;
  try {
    const running = await acknowledge(session.sessionId, command.id, {
      status: "running",
      version: command.version,
    });
    runningVersion = running.command.version;

    if (command.commandType === "retry_due_operations") {
      await retryRecoverable(session);
    } else if (command.commandType === "refresh_workspace") {
      await refreshWorkspace(session);
    } else if (command.commandType !== "upload_health_snapshot") {
      throw new Error("Unsupported sync command");
    }

    await acknowledge(session.sessionId, command.id, {
      resultCode: "COMMAND_APPLIED",
      resultMessage: commandResultMessage(command.commandType),
      status: "completed",
      version: runningVersion,
    });
  } catch {
    if (runningVersion != null) {
      await acknowledge(session.sessionId, command.id, {
        resultCode: "COMMAND_FAILED",
        resultMessage: "The web client could not complete the safe sync command.",
        status: "failed",
        version: runningVersion,
      }).catch(() => null);
    }
  }
}

function commandResultMessage(commandType) {
  if (commandType === "retry_due_operations") {
    return "Recoverable web sync operations were returned to the queue.";
  }
  if (commandType === "refresh_workspace") {
    return "The latest workspace snapshot was pulled and stored locally.";
  }
  return "A fresh privacy-safe web sync health snapshot was uploaded.";
}
